import { Injectable } from "@angular/core";
import { Message } from "primeng/primeng";
import { MatPaginatorIntl } from "@angular/material";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class GlobalAppService {
  private $msg = new Subject<Message>();

  private msg: Message = {};

  private loading$ = new BehaviorSubject<boolean>(false);

  constructor(private paginatorService: MatPaginatorIntl) {
    this.paginatorService.itemsPerPageLabel = "Items por página";
    this.paginatorService.nextPageLabel = "Siguiente";
    this.paginatorService.previousPageLabel = "Anterior";
    this.paginatorService.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length == 0 || pageSize == 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }
  public getMsgs(): Observable<Message> {
    return this.$msg.asObservable();
  }

  public sendMsg(severity: string, summary: string, detail: string) {
    this.msg = { severity: severity, summary: summary, detail: detail };
    this.$msg.next(this.msg);
  }

  public getLoading(): Observable<boolean> {
    return this.loading$.asObservable();
  }

  public setLoading(loading: boolean) {
    this.loading$.next(loading);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/commons/global-app.service.ts